module.exports = __webpack_public_path__ + "static/img/noticeboard.a4148c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/corridor/noticeboard.svg
// module id = 161
// module chunks = 2